import { render, staticRenderFns } from "./KyDetail.vue?vue&type=template&id=bf9d021c&scoped=true&"
import script from "./KyDetail.vue?vue&type=script&lang=js&"
export * from "./KyDetail.vue?vue&type=script&lang=js&"
import style0 from "./KyDetail.vue?vue&type=style&index=0&id=bf9d021c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf9d021c",
  null
  
)

component.options.__file = "KyDetail.vue"
export default component.exports